import { DateContextProvider } from "./DateContext";
import { DriversContextProvider } from "./DriversContext";
import { MapContextProvider } from "./MapContext";

const DataProviders = ({ children }: { children: React.ReactElement }) => {
    return (
        <DriversContextProvider>
            <DateContextProvider>
                <MapContextProvider>{children}</MapContextProvider>
            </DateContextProvider>
        </DriversContextProvider>
    );
};

export default DataProviders;
